<div class="container">
<!--  <div class="row justify-content-center">
    <div class="col-10 text-center">
      <input placeholder="Credit card number">
    </div>
  </div>
-->
  <div class="row justify-content-center">
    <div class="col-10 text-center">
      <a mat-raised-button color="primary" (click)="onPaymentSuccess()">Payment Success</a>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-10 text-center">
      <a mat-raised-button color="warn" (click)="onPaymentCancel()">Payment Cancel</a>
    </div>
  </div>
</div>
